module.exports = __webpack_public_path__ + "static/img/rank_127.2f92036.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_127.png
// module id = I2RK
// module chunks = 1